import AddAppointment from "components/appointment/AddAppointment";
import AddDayOffModal from "components/appointment/AddDayOffModal";
import AddTravelTimeModal from "components/appointment/AddTravelTimeModal";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Navbar } from "reactstrap";
import { appointmentsSelector } from "slices/appointmentSlice";
import { closeAppointmentPopup, setAddAppointmentPopup } from "slices/appointmentSlice";
import { fetchDashboardAnalytics } from "slices/dashboardSlice";
import { fetchDashboardAppointments } from "slices/dashboardSlice";
import { interpreterProfileSelector } from "slices/interpreter/profileSlice";
import { cdn } from 'constants/common';
import AddLunchSheduleModal from "components/lunch/AddLunch";
import { FaUtensils, FaCalendarTimes, FaCar } from "react-icons/fa";
import LunchStatusSwitch from "components/lunchSwitch/lunchSwitch";
import { fetchLunchSchedule } from "slices/citySlice";
import { fetchInterpreterDashboardAppointments } from "slices/interpreter/dashboardSlice";
let userSlice;
function Header(props) {
  const [color] = React.useState("transparent");
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { popup: appointmentPopUpState } = useSelector(appointmentsSelector);
  const [lunchShuduleModal, setlunchShuduleModal] = React.useState({
      show: false,
      item: {}
    });
  const [dayOffModal, setDayOffModal] = React.useState(false);
  const [travelTimeModal, setTravelTimeModal] = React.useState(false);
  const [lunchStatus, setlunchStatus] = useState([]);

  const refDropdown = React.useRef(null);
    useEffect(() => {
      dispatch(fetchLunchSchedule(false, true)).then((res) => {
        setlunchStatus(res.data);
      });
    }, [dispatch]);

  useEffect(() => {
    userSlice = require("../../slices/userSlice");
  }, []);

  const { interpreterProfile } = useSelector(interpreterProfileSelector);
  const displayUser = interpreterProfile?.user;
  
  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (refDropdown.current && !refDropdown.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Close dropdown on route change
  useEffect(() => {
    setDropdownOpen(false);
  }, [location]);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleLogout = () => {
    dispatch(userSlice.logout());
    navigate("/login", { replace: true });
  };
  const handleLunchClose = () => {
    setlunchShuduleModal({
      show: false,
      item: {}
    });
  };

  return (
    <>
      <Navbar
        expand="lg"
        className={
          location.pathname.indexOf("full-screen-maps") !== -1
            ? "navbar-absolute border-0 fixed-top"
            : "navbar-absolute border-0 fixed-top " +
              (color === "transparent" ? "navbar-transparent " : "")
        }
      >
        <AddLunchSheduleModal
          item={lunchShuduleModal.item}
          show={lunchShuduleModal.show}
          onClose={handleLunchClose}
        />
        <AddDayOffModal
          show={dayOffModal}
          onClose={() => setDayOffModal(false)}
          onSuccess={() => {
            const today = new Date().toISOString().slice(0, 10);
            dispatch(fetchInterpreterDashboardAppointments(1, { pageLength: 10, sortBy: 'date', sortDirection: 'desc', type: [0, 1, 4, 5], start_date: today, end_date: today }));
          }}
        />
        <AddTravelTimeModal
          show={travelTimeModal}
          onClose={() => setTravelTimeModal(false)}
          isAdmin={false}
          onSuccess={() => {
            const today = new Date().toISOString().slice(0, 10);
            dispatch(fetchInterpreterDashboardAppointments(1, { pageLength: 10, sortBy: 'date', sortDirection: 'desc', type: [0, 1, 4, 5], start_date: today, end_date: today }));
          }}
        />
        <div className="header">
          <button className="toggle_sidebar" onClick={props.toggleSidebar}>
            <img src="/images/ham.png" alt="" />
          </button>

          <div className="row_user_side">
            <div ref={refDropdown} className="d-flex align-items-center gap-2 position-relative">
              <LunchStatusSwitch userLunchStatus={lunchStatus} />
              <button
                onClick={() => setDayOffModal(true)}
                title="Add Day Off"
                style={{ height: "38px", width: "38px", borderRadius: "50px", border: "none", cursor: "pointer", background: "#00897b22" }}
              >
                <FaCalendarTimes size={20} color="#00897b" />
              </button>
              <button
                onClick={() => setTravelTimeModal(true)}
                title="Add Travel Time"
                style={{ height: "38px", width: "38px", borderRadius: "50px", border: "none", cursor: "pointer", background: "#ff69b422" }}
              >
                <FaCar size={20} color="#e91e8c" />
              </button>
              <button
                onClick={() => setlunchShuduleModal({item:{},show:true})}
                style={{ height: "38px" , width: "38px" , borderRadius: "50px" ,border: "none", cursor: "pointer" }}
              >
                <FaUtensils size={22} color="#C6C3BD" />
              </button>
              <button className="user_image" onClick={toggleDropdown}>
                {/* <img src="/images/default-person.png" alt="s" /> */}
                  {displayUser?.image ? (
                    <img src={cdn + displayUser.image} alt={displayUser.name} />
                  ) : (
                    <img src="/images/default-person.png" alt="Default profile" />
                  )}
                <span></span>
              </button>

              <button
                className={`drop_icon ${dropdownOpen ? "active" : ""}`}
                onClick={toggleDropdown}
              >
                <img src="/images/drop.png" alt="" />
              </button>

              <div
                className={`drop_more_selector ${
                  dropdownOpen ? "active" : ""
                }`}
              >
                <ul>
                  <li>
                    <Link to="/interpreter/profile">Profile</Link>
                  </li>
                  <li>
                    <Link to="/interpreter/change-password">Change Password</Link>
                  </li>
                  <li>
                    <Link href="#!">Help</Link>
                  </li>
                  <li>
                    <a
                      href=""
                      onClick={handleLogout}
                      className="red_clr"
                    >
                      Log Out
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Navbar>
    </>
  );
}

export default Header;
